import script from "./Description.vue?vue&type=script&setup=true&lang=ts"
export * from "./Description.vue?vue&type=script&setup=true&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=a62646f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a62646f2"]])

export default __exports__